import { render, staticRenderFns } from "./TripSummaryItem.vue?vue&type=template&id=4e9f710e&scoped=true&"
import script from "./TripSummaryItem.vue?vue&type=script&lang=ts&"
export * from "./TripSummaryItem.vue?vue&type=script&lang=ts&"
import style0 from "./TripSummaryItem.vue?vue&type=style&index=0&id=4e9f710e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f710e",
  null
  
)

export default component.exports